import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { api, types } from "api";
import { ComponentProps, Loader } from "components/Loader";
import React, { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ParentMetricsPage } from "./IndividualMetricsPage";

export const StudentMetrics = ({ setLoading }: ComponentProps): JSX.Element => {
	const [child, setChild] = React.useState("");
	const [childId, setChildId] = React.useState("");
	const { userId } = useParams<{ userId: types.UUID }>();
	// const [childrenList, setChildList] = React.useState("");

	const fetchId = useCallback(() => {
		// no userId given
		// need to retrieve it via /people/me first
		api
			.getMyUserData()
			.then((res) => {
				if (res.status !== 200) {
					throw new Error();
				}

				return res.data;
			})
			.then((respUserId) => {
				if (userId === undefined) {
					setChild(respUserId.firstName);
				} else {
					api
						.getUserDetails(userId)
						.then((res) => {
							if (res.status !== 200) {
								throw new Error();
							}

							return res.data;
						})
						.then((response) => {
							setChild(response.firstName);
							setChildId(response.userId);
						})
						.catch(() => {});
				}

				setChildId(respUserId.userId);
			})
			.catch(() => {});
	}, [userId]);

	useEffect(() => {
		fetchId();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Grid container spacing={2}>
			<Grid item xs={10}>
				<Typography variant="h2" data-testid="hello">
					{child} - Metrics
				</Typography>
			</Grid>
			<ParentMetricsPage setLoading={setLoading} uuid={childId} />
		</Grid>
	);
};

export const StudentMetricsLoadingPage = Loader(
	StudentMetrics,
	"We are fetching your data",
);
